import { DIC } from "@/const/dic";
import { baseUrl } from "@/config/env";
import { formatterTime } from "@/util/util";

export const customerFileTableOption = {
  align: "center",
  menuAlign: "center",
  headerAlign: "center",
  border: true,
  expand: false,
  stripe: false,
  showHeader: true,
  index: false,
  selection: true,
  menu: true,
  page: true,
  addBtn: false,
  editBtn: false,
  delBtn: false,
  columnBtn: false,
  viewBtn: false,
  menuWidth: "220",
  labelWidth: "200",
  defaultSort: {
    prop: "createTime",
    order: "descending",
  },
  column: [
    {
      label: "初期编号",
      prop: "initialNumber",
      type: "input",
      width: "190",
      // viewVisdiplay: false,
      //   hide: true,
      span: 13,
    },
    {
      label: "客户姓名",
      prop: "customerName",
      search: true,
      type: "input",
      rules: [
        {
          required: true,
          trigger: "blur",
          message: "请输入客户姓名",
        },
      ],
      span: 13,
    },
    {
      label: "客户电话",
      prop: "customerPhone",
      search: true,
      type: "input",
      rules: [
        {
          required: true,
          trigger: "blur",
          message: "请输入客户电话",
        },
      ],
      span: 13,
    },
    {
      label: "签单时间",
      prop: "signingTime",
      type: "datetime",
      valueFormat: "timestamp",
      format: "yyyy-MM-dd HH:mm:ss",
      addVisdiplay: true,
      viewVisdiplay: false,
      span: 13,
    },
    {
      label: "金蝶系统编号",
      prop: "kingDeeNumber",
      width: "150",
      type: "input",
      viewVisdiplay: false,
      span: 13,
    },
    {
      label: "项目地址",
      placeholder: "请输入详细地址",
      prop: "projectAddress",
      type: "input",
      search: true,
     /*  formsolt: true,
      rules: [
        {
          required: false,
          trigger: "blur",
          message: "请输入项目地址",
        },
      ],
      formatter: function(row, value, label, column) {
        let a = row.provinceName + row.cityName + row.areaName + row.address;
        if (a != 0) {
          return a;
        }
      }, */
      span: 18,
    },
    // 签约类型signing_type
    {
      label: "签约类型",
      prop: "signingType",
      type: "select",
      search: true,
      dicData: DIC.SIGINING_TYPE,
      span: 13,
    },
    // 系统类型system_types
    {
      label: "系统类型",
      prop: "systemType",
      type: "select",
      search: true,
      dicData: DIC.SYSTEM_TYPES,
      span: 13,
    },
    // salesman业务员
    {
      label: "业务员",
      prop: "salesman",
      type: "input",
      search: true,
      span: 13,
    },
    // 是否已经签订合同sign_contract
    {
      label: "是否已经签订合同",
      prop: "signContract",
      type: "select",
      search: true,
      dicData: DIC.SIGIN_CONTRACT,
      span: 13,
    },
    // contract_price合同价格
    {
      label: "合同价格",
      prop: "contractPrice",
      type: "input",
      search: true,
      span: 13,
    },
    // 施工进度construction_scheduling
    {
      label: "施工进度",
      prop: "constructionScheduling",
      type: "select",
      search: true,
      dicData: DIC.CONSTRUCTION_SCHEDULING,
      span: 13,
    },
    // progress_explanation具体进度阐述
    {
      label: "具体进度阐述",
      prop: "progressExplanation",
      type: "input",
      search: true,
      span: 13,
    },
    // 是否报完工reporting
    {
      label: "是否报完工",
      prop: "reporting",
      type: "select",
      search: true,
      dicData: DIC.REPORTING,
      span: 13,
    },
    //完工时间completion_time
    {
      label: "完工时间",
      prop: "completionTime",
      type: "datetime",
      valueFormat: "timestamp",
      format: "yyyy-MM-dd HH:mm:ss",
      span: 13,
    },
    //质保期warranty_period
    {
      label: "质保期",
      prop: "warrantyPeriod",
      type: "select",
      search: true,
      dicData: DIC.WARRANTY_PERIOD,
      span: 13,
    },
    // 前期照片previous_photos
    {
      label: "前期照片",
      prop: "previousPhotos",
      solt: true,
    },
    // 中期照片mid_term_photos
    {
      label: "中期照片",
      prop: "midTermPhotos",
      solt: true,
    },
    //完工照片completion_photos
    {
      label: "完工照片",
      prop: "completionPhotos",
      solt: true,
    },
    // 备注remarks
    {
      label: "备注",
      prop: "remarks",
      type: "input",
      span: 13,
    },
  ],
};
